import { useCallback, useMemo, useState } from 'react';
import { BIZ, comma, toNumber, won } from './data';

// 업종 선택 UI(#calculator 섹션)를 걷어내면서 기본 업종 기준으로 고정한다.
const DEFAULT_BIZ = BIZ[0];

/**
 * 월 예상 부담금액 = 월 예상 납부금액 × (1 - 이 비율).
 * 시안 수치(833만원 → 583만원)에서 역산한 값이다. 근거가 되는 비용처리 효과 비율이
 * 정해지면 여기만 바꾼다.
 */
const BURDEN_OFFSET_RATE = 0.3;

/** 줄바꿈 없는 공백 — 좁은 화면에서 '× / 12개월'처럼 곱셈식이 끊기지 않게 한다 */
const NB = ' ';

/** 히어로 '예상 납부금액' 카드 상태 */
export default function useEstimate() {
  const [sales, setSales] = useState(5000); // 월평균 온라인·카드매출 (만원)
  const [margin, setMargin] = useState(20); // 이익률 (%)

  const onSales = useCallback((e) => setSales(toNumber(e.target.value)), []);
  const onMargin = useCallback((e) => setMargin(Math.min(100, toNumber(e.target.value))), []);

  return useMemo(() => {
    const yearSales = sales * 12;
    const costRate = 100 - margin; // 매입·필요경비 비율
    const costAmount = (yearSales * costRate) / 100;
    const limit = sales * DEFAULT_BIZ.mult;
    const monthPay = limit / 12;

    return {
      salesVal: comma(sales),
      marginVal: String(margin),
      onSales,
      onMargin,

      yearSalesLabel: won(yearSales),
      yearSalesNote: `월평균 매출 ${won(sales)}${NB}×${NB}12개월`,

      costAmountLabel: won(costAmount),
      costAmountNote: `1년 매출액 ${won(yearSales)}${NB}×${NB}${costRate}%`,
      costBasisNote: `※ 이익률 ${margin}% 기준, 매입·필요경비 비율 ${costRate}%로 계산`,

      limitLabel: won(limit),
      periodLabel: DEFAULT_BIZ.cycle,
      monthPayLabel: won(monthPay),
      monthBurdenLabel: won(monthPay * (1 - BURDEN_OFFSET_RATE)),
    };
  }, [margin, onMargin, onSales, sales]);
}
